import React from 'react';
import ButtonLink from './ButtonLink';
import theme from '../theme';
import fn from '../../helpers/fn';

export default fn(__filename, ButtonLink.extend`
  ${({ inverted }) => (inverted ? `
    color: ${theme.colors.action};
    background: ${theme.colors.white};
  ` : `
    color: ${theme.colors.white};
    background: ${theme.colors.action};
  `)}
`.withComponent(({
  inverted, // strip,
  ...props
}) => <ButtonLink {...props} />));



// WEBPACK FOOTER //
// ./src/components/links/ActionButtonLink.js